import isRequestSignatureDatePopup from './isRequestSignatureDatePopup';

export default popup =>
  !!(
    isRequestSignatureDatePopup(popup) &&
    popup.contentSettings.text &&
    popup.contentSettings.text.length > 0
  );



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isFilledDatePopup.jsx